class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.heading = this.querySelector('.cart-notification__heading');
    this.headingTextNode = this.heading
      ? Array.from(this.heading.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
        )
      : null;
    this.singleItemHeading = this.headingTextNode ? this.headingTextNode.nodeValue : '';

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const addedItemKeys =
      Array.isArray(parsedState.addedItemKeys) && parsedState.addedItemKeys.length
        ? parsedState.addedItemKeys
        : [this.cartItemKey];

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target || !parsedState.sections || !parsedState.sections[section.id]) return;

      if (section.id === 'cart-notification-product' && addedItemKeys.length > 1) {
        target.innerHTML = this.getMultipleProductsSectionHTML(
          parsedState.sections[section.id],
          addedItemKeys
        );
        target.classList.add('cart-notification-product--multiple');
      } else {
        target.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );

        if (section.id === 'cart-notification-product') {
          target.classList.remove('cart-notification-product--multiple');
        }
      }
    });

    this.updateHeading(parsedState.itemsAddedCount || addedItemKeys.length);
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getMultipleProductsSectionHTML(html, keys) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');

    return keys
      .map((key) => parsedDocument.getElementById(`cart-notification-product-${key}`))
      .filter(Boolean)
      .map((item) => item.outerHTML)
      .join('');
  }

  updateHeading(itemCount) {
    if (!this.headingTextNode) return;

    this.headingTextNode.nodeValue =
      Number(itemCount) > 1
        ? ` ${itemCount} items added to your cart`
        : this.singleItemHeading;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
